__turbopack_context__.v({
  "actions": "team-plan-header-module-scss-module__PDg7Ua__actions",
  "header": "team-plan-header-module-scss-module__PDg7Ua__header",
  "shell": "team-plan-header-module-scss-module__PDg7Ua__shell",
});
